<template>
	<v-container grid-list-md>
		<v-layout wrap row>
			<v-flex xs12>
				<v-container grid-list-xl>
					<v-layout row wrap>
						<v-flex
							xs12
							md3
							v-for="(statistic, index) in statistics"
							:key="index"
						>
							<Link :href="$route(statistic.link)" :key="index">
								<v-card class="mx-auto">
									<v-list
										two-line
										:color="statistic.color"
										dark
									>
										<v-list-item>
											<v-list-item-content>
												<v-list-item-title>
													<h1>
														{{ statistic.value }}
													</h1>
												</v-list-item-title>
												<v-list-item-subtitle
													class="white--text"
													>{{
														statistic.title
													}}</v-list-item-subtitle
												>
											</v-list-item-content>
											<v-list-item-content>
												<v-icon size="50">{{
													statistic.icon
												}}</v-icon>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-card>
							</Link>
						</v-flex>
					</v-layout>
				</v-container>
			</v-flex></v-layout
		>
	</v-container>
</template>
<script>
	import { Link } from "@inertiajs/inertia-vue";
	export default {
		props: ["data"],
		components: {
			Link,
		},
		computed: {
			statistics() {
				return [
					{
						icon: "mdi-map-marker",
						title: this.$t("title.locations"),
						link: "central.locations.index",
						role: "admin|manager",
						color: "#C09949",
						value: this.data.locations,
					},

					{
						icon: "mdi-home-city-outline",
						title: this.$t("title.brands"),
						link: "central.tenants.index",
						role: "admin|manager",
						color: "#C09949",
						value: this.data.brands,
					},
					{
						icon: "mdi-home-variant-outline",
						title: this.$t("title.outlets"),
						link: "central.index",
						role: "admin|manager",
						color: "#C09949",
						value: this.data.outlets,
					},
					{
						icon: "mdi-food",
						title: this.$t("title.products"),
						link: "central.index",
						role: "admin|manager",
						color: "#c09949",
						value: this.data.products,
					},
					{
						icon: "mdi-account-cash-outline",
						title: this.$t("title.customers"),
						link: "central.index",
						role: "admin|manager",
						color: "#141F35",
						value: this.data.customers,
					},
					{
						icon: "mdi-calendar-month",
						title: this.$t("title.reservations"),
						link: "central.reservations.index",
						role: "admin|manager",
						color: "#141F35",
						value: this.data.reservations,
					},
					{
						icon: "mdi-clipboard-list-outline",
						title: this.$t("title.orders"),
						link: "central.index",
						role: "admin|manager",
						color: "#141F35",
						value: this.data.orders,
					},
					{
						icon: "mdi-table-account",
						title: this.$t("title.outlet_tables"),
						link: "central.index",
						role: "admin|manager",
						color: "#141F35",
						value: this.data.tables,
					},
					{
						icon: "mdi-dice-5",
						title: this.$t("title.coupons"),
						link: "central.coupons.index",
						role: "admin|manager",
						color: "#5D5C5C",
						value: this.data.coupons,
					},
					{
						icon: "mdi-currency-usd",
						title: this.$t("title.topups"),
						link: "central.topups.index",
						role: "admin|manager",
						color: "#5D5C5C",
						value: this.data.topups,
					},
					{
						icon: "mdi-card-bulleted",
						title: this.$t("title.subscriptions"),
						link: "central.subscriptions.index",
						role: "admin|manager",
						color: "#5D5C5C",
						value: this.data.subscriptions,
					},
					{
						icon: "mdi-bullhorn",
						title: this.$t("title.promotions"),
						link: "central.index",
						role: "admin|manager",
						color: "#5D5C5C",
						value: this.data.promotions,
					},
				];
			},
		},
	};
</script>
